export default {
  wrapper: {
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  chips: {
    display: 'flex',
    gap: '4px',
    flexWrap: 'wrap',
  },
  chip: {
    height: '20px',
    display: 'flex',
    gap: '4px',
    alignItems: 'center',
    borderRadius: '20px',
    padding: '6px',
    fontSize: '.75rem',
    background: (theme) => theme.palette.grays.gray200,
    color: (theme) => theme.palette.grays.gray700,
  },
  icon: {
    cursor: 'pointer',
    width: '8px',
    color: (theme) => theme.palette.grays.gray700,
    '&:hover': {
      color: (theme) => theme.palette.grays.gray700,
    },
  },
  input: {
    '& .MuiInputBase-input': {
      height: '40px',
      padding: 0,
      border: 'none',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none',
      borderWidth: '0',
    },
  },
};
